import {Activity} from '../activity/activity';
import {Attachment} from '../attachment/attachment';
import {FaultData} from './fault-data';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {MmModel} from '@docma-mm-core/model/mm.model';
import {MmSyncableModel} from '@docma-mm-core/model/mm-syncable.model';
import {Project} from '@docma-mm-core/project/project';
import {Coordinate} from '@docma-mm-core/plan/plan';
import {BehaviorSubject} from 'rxjs';
import {Group} from '@docma-mm-core/group/group';
import {BpPin} from '../../bp-common/models/bp-pin';


export class Fault extends MmSyncableModel<FaultData>  {

  private attachmentsSubject = new BehaviorSubject<Array<Attachment>>([]);
  public attachments$ = this.attachmentsSubject.asObservable();

  private activitiesSubject = new BehaviorSubject<Array<Activity>>([]);
  public activities$ = this.activitiesSubject.asObservable();

  private groupsSubject = new BehaviorSubject<Array<Group>>([]);
  public groups$ = this.groupsSubject.asObservable();

  downloaded = false;
  pin: Coordinate;
  bpPin: BpPin;
  attributeId?: number;
  pinText?: string;
  isLocked = false;

  constructor(init?: Partial<Fault>) {
    super(init);
    if (!this.uid && init && init.uid) {
      this.uid = init.uid;
    }
    if (init) {
      this.downloaded = !!init.downloaded;
      if (init.activities && init.activities.length > 0) {
        this.activities = [];
        this.addActivities(init.activities.map(a => new Activity(a)));
      }
      if (init.attachments && init.attachments.length > 0) {
        this.attachments = [];
        init.attachments.map(a => ({initAtt: a, newAtt: new Attachment(a)}))
          .forEach(a => {
            a.newAtt.addScribbles(a.initAtt.scribbles);
            this.addAttachment(a.newAtt);
          } );
      }
      this.pin = init.pin;
      this.bpPin = init.bpPin;
      this.data.IsLocked = init.isLocked;
      this.data.Attribute = (init?.attributeId ? { Id: init.attributeId } : undefined);
      this.pinText = (init?.pinText?.length > 25 ? init?.pinText.slice(0, 25) + '...' : init?.pinText);
      this.attributeId = init.attributeId;

    }
  }

  public GetGroups(activities: Array<Activity>): { [uid: string]: Group } {
    return activities
      .reduce((acc, curr) => {
        if (curr.group) {
          const uid = curr.group.uid;

          if (acc[uid] == null) {
            const grp = new Group();
            grp.id = curr.group.id;
            grp.uid = curr.group.uid;

            acc[uid] = [];
            acc[uid].push(grp);
          }
        }
        return acc;
      }, {});
  }

  get isNew(): boolean {
    return !this.id;
  }

  get attachments(): Attachment[] {
    return this.attachmentsSubject.value;
  }
  set attachments(v: Attachment[]) {
    this.attachmentsSubject.next(v);
  }

  get activities(): Activity[] {
    return this.activitiesSubject.value;
  }
  set activities(v: Activity[]) {
    this.activitiesSubject.next(v);
  }

  // get groups(): Group[] {
  //   return this._groups.value;
  // }
  // set groups(v: Group[]) {
  //   this._groups.next(v);
  // }

  addActivity(activity: Activity) {

    if (!this.activities || this.activities.length === 0 || !this.activities.find(a => a == activity)) {
      const newArray = [...this.activities || []];
      activity.fault = {id: this.id, uid: this.uid};
      newArray.push(activity);
      this.activities = newArray;
      // this.initGroups();
    }
  }

  addActivities(activities: Activity[]) {

    if (!this.activities || this.activities.length === 0) {
      const newArray = [...this.activities || []];
      for (const activity of activities) {
        if (!this.activities.find(a => a === activity)) {
          activity.fault = { id: this.id, uid: this.uid };
          newArray.push(activity);
        }
      }
      this.activities = newArray;
      // this.initGroups();
    }
  }

  // initGroups() {
  //   let groupsDict = this.GetGroups(this.activities);
  //     if (groupsDict) {
  //       this.groups = []
  //       this.groups =  Object.values(groupsDict);
  //     }
  // }

  removeActivity(activity: Activity) {
    if (this.activities && this.activities.length > 0 ) {
      const index = this.activities.findIndex(a => a == activity);
      if (index >= 0) {
        const newArray = [...this.activities ];
        newArray.splice(index, 1);
        this.activities = newArray;
        // this.initGroups();
      }
    }
  }

  removeActivities(activities: Activity[]) {
    if (this.activities && this.activities.length > 0 ) {
      const newArray = [...this.activities ];
      for (const activity of activities) {
        const index = this.activities.findIndex(a => a === activity);
        if (index >= 0) {
          newArray.splice(index, 1);
        }
      }
      this.activities = newArray;
      // this.initGroups();
    }
  }

  addAttachment(attachment: Attachment) {

    if (!this.attachments || this.attachments.length === 0 || !this.attachments.find(a => a === attachment)) {
      const newArray = [...this.attachments || []];
      attachment.fault = { id: this.id, uid: this.uid };
      newArray.push(attachment);
      this.attachments = newArray;
    }
  }

  removeAttachment(attachment: Attachment) {

    if (this.attachments && this.attachments.length > 0 ) {
      const index = this.attachments.findIndex(a => a === attachment);
      if (index >= 0) {
        const newAttachments = [...this.attachments ];
        newAttachments.splice(index, 1);
        this.attachments = newAttachments;
      }
    }
  }

  removeAttachmentFromActivity(attachment: Attachment, activity: Activity) {
    if (this.activities && this.activities.length > 0 ) {
      const activityIndex = this.activities.findIndex(a => a === activity);
      const attachmentIndex = activity.attachments.findIndex(a => a === attachment);

      const newAttachments = [...activity.attachments ];
      newAttachments.splice(attachmentIndex, 1);
      activity.attachments = newAttachments;

      const newActivities = [...this.activities];
      newActivities[activityIndex] = activity;
      this.activities = newActivities;
    }
  }

  hasAnyChanges(): boolean {
    if (this.changeState && this.changeState.status !== ChangeStatusEnum.NotChanged) {
      return true;
    }
    if (this.attachments) {
      if (this.attachments.some(a => a.changeState && a.changeState.status !== ChangeStatusEnum.NotChanged)) {
        return true;
      }
      if (this.attachments.flatMap(x => x.scribbles).some(sc => sc.changeState && sc.changeState.status !== ChangeStatusEnum.NotChanged)) {
        return true;
      }
    }

    if (this.activities) {
      for (const a of this.activities) {
        if (a.changeState && a.changeState.status !== ChangeStatusEnum.NotChanged) {
          return true;
        }
        if (a.attachments) {
          if (a.attachments.some(aa => aa.changeState && aa.changeState.status !== ChangeStatusEnum.NotChanged)) {
            return true;
          }
          if (a.attachments.flatMap(x => x.scribbles).some(sc => sc.changeState && sc.changeState.status !== ChangeStatusEnum.NotChanged)) {
            return true;
          }
        }
      }
    }

  }
}

export class LayoutFault extends MmModel<any>  {
  isLocked?: boolean;

  constructor(init?: Partial<LayoutFault>) {
    super(init);
    this.isLocked = init.isLocked;
  }
}

export class ViewFault extends Fault {

  constructor(init?: Partial<ViewFault>) {
    super(init);
    if (init) {
      this.project = init.project;
      this.isChecked = init.isChecked;
      this.unsavedNew =  init.unsavedNew;
     }
    this.layoutState = init && init.layoutState || new MmModel();

    // this.syncState$.pipe(untilDestroyed(this))
    //   .subscribe(x => {
    //     console.debug("syncState$" + JSON.stringify(x.status));
    //   });

    // this.loadState$.pipe(untilDestroyed(this))
    //   .subscribe(x => {
    //     console.debug("loadState$" + JSON.stringify(x.status));
    //   });

    // this.changeState$.pipe(untilDestroyed(this))
    //   .subscribe(x => {
    //     console.debug("changeState$" + JSON.stringify(x.status));
    //   });
  }


  layoutState: MmModel<any> ;

  isChecked = false;
  unsavedNew = false;
  project: Project;


  firstLoad?: boolean;

  get identifier() {
    return this.id || this.uid;
  }
}

